import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState<{ tipo: 'success' | 'error'; texto: string } | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setMensagem({ tipo: 'error', texto: 'Por favor, informe seu email.' });
      return;
    }

    setLoading(true);
    setMensagem(null);

    try {
      console.log('[ForgotPassword] Solicitando reset de senha:', { email });
      
      const response = await api.post('/auth/forgot-password', { email });

      if (response.data.sucesso) {
        setMensagem({ 
          tipo: 'success', 
          texto: response.data.mensagem || 'Link de recuperação enviado para seu email!' 
        });
        setEmail('');
      } else {
        setMensagem({ 
          tipo: 'error', 
          texto: response.data.mensagem || 'Erro ao enviar link de recuperação.' 
        });
      }
    } catch (error: any) {
      console.error('[ForgotPassword] Erro ao solicitar reset:', error);
      setMensagem({ 
        tipo: 'error', 
        texto: error.response?.data?.mensagem || 'Erro ao processar solicitação. Tente novamente.' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="card card-outline card-primary">
          <div className="card-header text-center">
            <h1 className="mb-0">
              <b>Sistema</b> Sophya
            </h1>
          </div>
          <div className="card-body">
            <p className="login-box-msg">Esqueceu sua senha? Digite seu email abaixo.</p>

            {mensagem && (
              <div className={`alert alert-${mensagem.tipo === 'success' ? 'success' : 'danger'} alert-dismissible fade show`}>
                <button type="button" className="btn-close" onClick={() => setMensagem(null)}></button>
                {mensagem.texto}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <div className="input-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                    required
                  />
                  <div className="input-group-text">
                    <i className="bi bi-envelope"></i>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <button 
                    type="submit" 
                    className="btn btn-primary w-100"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Enviando...
                      </>
                    ) : (
                      'Enviar Link de Recuperação'
                    )}
                  </button>
                </div>
              </div>
            </form>

            <div className="mt-3 text-center">
              <button 
                className="btn btn-link"
                onClick={() => navigate('/login')}
                disabled={loading}
              >
                Voltar para o Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
